module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ax-c260e9a581b4c4415f206107819ae3b4.svg";